module.exports = __webpack_public_path__ + "img/staff.a056449d.png";